/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { AdOnBoardPassengersVehicleFragmentDoc } from '../../../../ad-passenger-list/src/lib/AdOnBoardPassengers/AdOnBoardPassengers.hook'
import { GetAlertSeverityAdAlertFragmentDoc } from '../../../../alerts-common/src/lib/utils/getAlertSeverity.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdAlertFeedCardVehicleFragment = {
  __typename?: 'Vehicle'
  label: number | null
  id: string
  fccHandledByOperator: {
    __typename?: 'BackofficeUser'
    id: string
    firstName: string
    lastName: string
  } | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      createdAt: string
      status: Types.FccAdAlertStatus
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    stop: {
      __typename?: 'Stop'
      id: string
      names: Partial<Record<'de' | 'en', string>>
    } | null
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
        }
      | { __typename?: 'FccWaypointHubReturnAction' }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
        }
      | { __typename?: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export type AdAlertFeedCardAlertFragment = {
  __typename: 'FccAdAlert'
  id: string
  type: Types.FccAdAlertType
  createdAt: string
  status: Types.FccAdAlertStatus
}

export type AdAlertFeedCardStartHandlingVehicleMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  isTakeOver: Types.Scalars['Boolean']['input']
}>

export type AdAlertFeedCardStartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export const AdAlertFeedCardAlertFragmentDoc = gql`
    fragment AdAlertFeedCardAlert on FccAdAlert {
  ...GetAlertSeverityAdAlert
  id
  type
  createdAt
  status
}
    ${GetAlertSeverityAdAlertFragmentDoc}`
export const AdAlertFeedCardVehicleFragmentDoc = gql`
    fragment AdAlertFeedCardVehicle on Vehicle {
  ...AdOnBoardPassengersVehicle
  label
  fccHandledByOperator {
    id
    firstName
    lastName
  }
  fccCurrentAdAlerts {
    alerts {
      ...AdAlertFeedCardAlert
    }
  }
}
    ${AdOnBoardPassengersVehicleFragmentDoc}
${AdAlertFeedCardAlertFragmentDoc}`
export const AdAlertFeedCardStartHandlingVehicleDocument = gql`
    mutation AdAlertFeedCardStartHandlingVehicle($vehicleId: ID!, $isTakeOver: Boolean!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId, isTakeOver: $isTakeOver)
}
    `
export type AdAlertFeedCardStartHandlingVehicleMutationFn =
  Apollo.MutationFunction<
    AdAlertFeedCardStartHandlingVehicleMutation,
    AdAlertFeedCardStartHandlingVehicleMutationVariables
  >

/**
 * __useAdAlertFeedCardStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useAdAlertFeedCardStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdAlertFeedCardStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adAlertFeedCardStartHandlingVehicleMutation, { data, loading, error }] = useAdAlertFeedCardStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      isTakeOver: // value for 'isTakeOver'
 *   },
 * });
 */
export function useAdAlertFeedCardStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdAlertFeedCardStartHandlingVehicleMutation,
    AdAlertFeedCardStartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdAlertFeedCardStartHandlingVehicleMutation,
    AdAlertFeedCardStartHandlingVehicleMutationVariables
  >(AdAlertFeedCardStartHandlingVehicleDocument, options)
}
export type AdAlertFeedCardStartHandlingVehicleMutationHookResult = ReturnType<
  typeof useAdAlertFeedCardStartHandlingVehicleMutation
>
export type AdAlertFeedCardStartHandlingVehicleMutationResult =
  Apollo.MutationResult<AdAlertFeedCardStartHandlingVehicleMutation>
export type AdAlertFeedCardStartHandlingVehicleMutationOptions =
  Apollo.BaseMutationOptions<
    AdAlertFeedCardStartHandlingVehicleMutation,
    AdAlertFeedCardStartHandlingVehicleMutationVariables
  >
